module.exports = __webpack_public_path__ + "img/pro_jinniao_01.a05efc9a.png";